<template>
    <q-dialog ref="dialogRef" @hide="onDialogHide">
        <q-card class="q-dialog-plugin">
            <q-card-section>
                <div class="text-h6">{{ ts( 'startTimeLong' ) }}</div>
            </q-card-section>

            <q-card-section class="q-pt-none">
                <q-radio v-model="type" val="fixed" :label="ts( 'fixedStartTime' )" />

                <div v-if="type === 'fixed'" class="q-mt-sm">
                    <q-input v-model="startTime" dense autofocus mask="fulltime" :rules="['fulltime']">
                        <template #append>
                            <q-icon name="access_time" class="cursor-pointer">
                                <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                                    <q-time v-model="startTime" flat now-btn with-seconds format24h>
                                        <div class="row items-center justify-end">
                                            <q-btn v-close-popup :label="ts( 'close' )" color="primary" flat />
                                        </div>
                                    </q-time>
                                </q-popup-proxy>
                            </q-icon>
                        </template>
                    </q-input>
                </div>

                <q-radio v-if="props.raceNo > 1" v-model="type" val="continuous" :label="ts( 'continuousStartTime' )" />
            </q-card-section>

            <q-card-actions align="right">
                <q-btn flat :label="ts( 'cancel' )" color="primary" @click="onDialogCancel" />
                <q-btn flat :label="ts( 'ok' )" color="primary" @click="onOKClick" />
            </q-card-actions>
        </q-card>
    </q-dialog>
</template>

<script setup lang="ts">
import { useDialogPluginComponent } from "quasar"
import { ts } from "@/plugins/i18nFormat"
import { ref } from "vue"
import { SPECIAL_BEHAVIOR_CONTINUOUS_START } from "@model/EventRaceDetailedClass"

interface Props {
    initialStartTime: string
    initialSpecialBehavior: string | null
    raceNo: number
}

const props = defineProps<Props>()

defineEmits( [ ...useDialogPluginComponent.emits ] )

const { dialogRef, onDialogHide, onDialogOK, onDialogCancel } = useDialogPluginComponent()

const type = ref( props.initialSpecialBehavior === SPECIAL_BEHAVIOR_CONTINUOUS_START ? 'continuous' : 'fixed' )
const startTime = ref( props.initialStartTime )

function onOKClick () {
    onDialogOK( {
        startTime: startTime.value,
        specialBehavior: type.value === 'continuous' ? SPECIAL_BEHAVIOR_CONTINUOUS_START : null
    } )
}
</script>
